<template>
  <div class="mains" v-loading="loading" element-loading-spinner="el-icon-loading">
    <div class="breadcrumb">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/lubricaOilManage',query: {active:'classification'} }">润滑油分类</el-breadcrumb-item>
        <el-breadcrumb-item>编辑分类</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="form-box">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="分类" prop="classification">
          <el-input v-model="form.classification" placeholder="请输入分类"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="onSubmit" size="small">提交</el-button>
          <el-button size="small" @click="$router.push({ path: '/lubricaOilManage',query: {active:'classification'} })">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      form: {},
      rules: {
        classification:[{ required: true, message: '必填项', trigger: 'blur' }],
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$ajax.post('lubeClassificationEdit', this.form).then(res => {
            this.loading = false
            this.$message.success('成功')
            this.$router.push({ path: '/lubricaOilManage',query: {active:'classification'} })
          }).catch(err=>{
            this.loading = false
          })
        }
      })
    }
  },
  mounted() {
    if (this.$route.params.row == null) {
      this.$router.push({ path: '/lubricaOilManage',query: {active:'classification'} })
      return;
    } 
    sessionStorage.setItem("detail", true);
    this.form = this.$route.params.row
  }
}
</script>

<style lang="less" scoped>
.mains {
  height: 100%;
}
/deep/.el-loading-spinner .el-icon-loading{
  font-size: 50px;
}
.breadcrumb {
  padding: 15px 10px;
  .el-breadcrumb {
    font-size: 18px;
  }
}
</style>